(function()
{
	//Import classes
	var BaseState = include('springroll.easeljs.BaseState'),
		IntroPanel = include('Lemonade.IntroPanel');

	/**
	 * The logic for the title state
	 * @class Lemonade.IntroState
	 * @extends springroll.easeljs.BaseState
	 */
	var IntroState = function(options)
	{
		BaseState.call(this, new IntroPanel(), options);

		// bind function scope here
		// this.onPlay = this.onPlay.bind(this);
	};

	// Extend the base class
	var p = extend(IntroState, BaseState);

	/**
	 * When the transition is done playing and we're fully in
	 */
	p.enterDone = function()
	{
		app.state = this;
		app.globalState.currentLocation = "Intro Screen";

		this.panel.playAnimationSequence();
		
		var introStart = Math.round((Date.now() - app.globalState.startTime)/ 1000);
		// temporary bypass
		this.panel.skipButton.addEventListener("click", function () {
			var skipTime = Math.round((Date.now() - app.globalState.startTime)/ 1000) - introStart;
			GTM_obj.trackGTMEvent('gameSkip', {'duration' : skipTime});
			this.nextState();
		}.bind(this));

		app.sound.play("ses-lem_outsideloop");
	};

	/**
	 * When the state fully exits
	 * @method  exit
	 */
	p.exit = function()
	{
		app.voPlayer.stop();
		app.sound.stop("ses-lem_outsideloop");
		createjs.Tween.removeTweens(this.panel);
		app.animator.stopAll();
	};

	//Assign to namespace
	namespace("Lemonade").IntroState = IntroState;
}());
